import React from 'react';

import { withForm } from '@gogame/form';

import CommentWithMarkForm from '../CommentWithMarkForm';
import { ReviewsSchema } from './schemas';

export const ReviewForm = withForm({
  validationSchema: ReviewsSchema,
  enableReinitialize: true,
})(({ values, onSubmitClick: onSubmit, validateForm }) => {
  const handleSubmit = async (_, { mark, comment }) => {
    if (validateForm({ ...values, mark, text: comment })) {
      onSubmit({ ...values, mark, text: comment });
    }
  };

  return (
    <CommentWithMarkForm
      label={'Review'}
      initialValue={values}
      onChange={handleSubmit}
    />
  );
});
